export default __webpack_public_path__ + "static/silver-a891eab54cba016f0f1c0f71548036f7.jpg";